module.exports = __webpack_public_path__ + "img/ocean-spa.227c256e.jpg";